'use client';

import { getCurrencySymbol } from '@campaign-manager/core/lib/utils';
import { useLocalization } from '@campaign-manager/feature/context/Localization';

import Value from '../Value';

interface Props {
  placeholder?: string;
}

export default function CurrencySymbol({ placeholder }: Props) {
  const { currency } = useLocalization();
  return (
    <Value
      value={CurrencySymbolString(currency)}
      placeholder={placeholder}
    />
  );
}

export function CurrencySymbolString(currency?: string | null | undefined) {
  return getCurrencySymbol(currency ?? undefined);
}
